import { type FC } from 'react'
import CourseTable from './CourseTable'
import { useUpcomingCoursesQuery } from './query'

const UpcomingCourseList: FC = () => {
  const { data, isLoading } = useUpcomingCoursesQuery()

  return <CourseTable datasource={data} isLoading={isLoading} />
}

export default UpcomingCourseList
